import { Week } from "../Week/Week";
import { MatDialogRef } from "@angular/material";
import { LoadingComponent } from "../../loading-components/loading/loading.component";
import { Area } from "../Area/Area";

export class RunConfig{

    companyid:number;
    companyLocationId:number;
    selectedCompany:any;
    selectedLocation:any;
    roundTripTime : number;
    pickupType:String;
    week : Week;
    loader : MatDialogRef<LoadingComponent,any>;
    origin : Area;
    forceOverwrite: boolean = false;
    avoidTolls:boolean = false;
    loadTime:number = 0;

    constructor(roundTripTime:any,week:Week,loader:MatDialogRef<LoadingComponent,any>,origin:Area,companyid:number,locid:number,avoidTolls:boolean){

        this.roundTripTime = parseInt(roundTripTime);
        this.week = week;
        this.loader = loader;
        this.origin = origin;
        this.companyid = companyid;
        this.companyLocationId = locid;
        this.avoidTolls = avoidTolls;
    }

    assignFromRawData(runConfig){
        this.avoidTolls = runConfig.avoidTolls;
        this.selectedCompany = runConfig.selectedCompany;
        this.selectedLocation = runConfig.selectedLocation;
        this.companyLocationId = runConfig.companyLocationId;
        this.loadTime = runConfig.loadTime;
        this.companyid = runConfig.companyid;
        this.roundTripTime = runConfig.roundTripTime;
        this.origin = Area.createAreaFromJson(runConfig.origin); 
    }

    generateReportName(){
  
        return this.selectedCompany.company_name + " : "+ this.week.getRange().getStartDate() + " - " + this.week.getRange().getEndDate();
    }

}